import { render, staticRenderFns } from "./LinkBtn.vue?vue&type=template&id=5cea40f7&"
import script from "./LinkBtn.vue?vue&type=script&lang=ts&"
export * from "./LinkBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports